import React, { useState, createContext, ReactElement } from 'react';

interface GroupVsRemainderContextType {
  peerGroupValues: (string | boolean)[] | undefined;
  setPeerGroupValues: React.Dispatch<
    React.SetStateAction<(string | boolean)[] | undefined>
  >;
}

const GroupVsRemainderContext = createContext<GroupVsRemainderContextType>({
  peerGroupValues: [],
  setPeerGroupValues: () => {},
});

const GroupVsRemainderProvider = ({ children }: { children: ReactElement }) => {
  const [peerGroupValues, setPeerGroupValues] = useState<
    (string | boolean)[] | undefined
  >();
  return (
    <GroupVsRemainderContext.Provider
      value={{
        peerGroupValues,
        setPeerGroupValues,
      }}
    >
      {children}
    </GroupVsRemainderContext.Provider>
  );
};

export { GroupVsRemainderContext, GroupVsRemainderProvider };
